
import { Screen } from "@/models/screen";
import { Ad } from "@/models/ad";
import { useCallback } from "react";

export const useAvailableScreens = (screens: Screen[]) => {
  const getAvailableScreens = useCallback(() => {
    // Filtrar pantallas que tengan al menos un espacio disponible
    return screens.filter(screen => screen.availableSpaces > 0);
  }, [screens]);
  
  const getAvailableScreensForEdit = useCallback((selectedAd: Ad | null) => {
    if (!selectedAd) return getAvailableScreens();
    
    // Obtener pantallas disponibles
    const availableScreens = getAvailableScreens();
    
    // Obtener las pantallas actuales del anuncio
    const currentScreenIds = selectedAd.screens.map(screen => screen.screenId);
    const currentScreens = screens.filter(screen => currentScreenIds.includes(screen.id));
    
    // Combinar pantallas disponibles con las actuales del anuncio (sin duplicar)
    return [
      ...availableScreens,
      ...currentScreens.filter(screen => !availableScreens.some(s => s.id === screen.id))
    ];
  }, [screens, getAvailableScreens]);
  
  // Añadimos una función para obtener todas las pantallas sin filtrar
  const getAllScreens = useCallback(() => {
    return screens;
  }, [screens]);
  
  return {
    getAvailableScreens,
    getAvailableScreensForEdit,
    getAllScreens // Exportamos la nueva función
  };
};
